var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSad = function SvgSad(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32780_38049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0C7.83502 0 0 7.83502 0 17.5C0 27.165 7.83502 35 17.5 35Z",
    fill: "#E2E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 17.5006C35 27.1693 27.1633 35.0006 17.5 35.0006C11.9984 35.0006 7.08751 32.4631 3.87735 28.4873C6.87969 30.9154 10.7023 32.3646 14.8641 32.3646C24.5273 32.3646 32.3641 24.5334 32.3641 14.8646C32.3641 10.7029 30.9149 6.88027 28.4867 3.87793C32.457 7.08809 35 11.999 35 17.5006Z",
    fill: "#CBD6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0083 27.6284C23.8614 27.8493 24.7058 27.2073 24.6719 26.3268C24.5275 22.573 21.4311 19.4395 17.5002 19.4395C13.5616 19.4395 10.4663 22.5818 10.3284 26.3388C10.2967 27.2149 11.1334 27.8591 11.9822 27.6415C15.7513 26.679 19.4241 26.6987 23.0083 27.6284Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5249 27.2999C21.5643 27.1183 21.5884 26.9313 21.5884 26.7366C21.5884 25.2721 20.4028 24.0864 18.9437 24.0864C18.2196 24.0864 17.5699 24.3708 17.0985 24.8367C16.777 24.7022 16.4281 24.6278 16.0573 24.6278C14.5982 24.6278 13.4126 25.8135 13.4126 27.2725C13.4126 27.2889 13.417 27.3042 13.4181 27.3206C16.1699 26.7978 18.8715 26.8011 21.5249 27.2999Z",
    fill: "#E24B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7573 23.9256C30.7573 22.6787 28.4998 18.8462 28.4998 18.8462C28.4998 18.8462 26.2423 22.6787 26.2423 23.9256C26.2423 25.1724 27.2529 26.1831 28.4998 26.1831C29.7466 26.1831 30.7573 25.1724 30.7573 23.9256Z",
    fill: "#65B1EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7407 18.5465L26.7862 16.4148C24.5385 13.9713 20.496 13.9002 20.4512 13.9002L19.341 13.8915L20.158 13.1357C21.1971 12.159 22.2996 11.7762 23.4098 11.9982C25.8707 12.4784 27.4523 15.7826 27.5146 15.9248L28.7407 18.5465Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8695 3.21875C23.3517 8.25984 24.72 8.50922 26.2633 9.89062C24.7714 9.88844 22.8573 9.21359 21.3742 7.87484C19.5443 6.15109 18.8531 4.33875 18.8695 3.21875Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14378 18.5465L8.09831 16.4148C10.346 13.9713 14.3885 13.9002 14.4333 13.9002L15.5435 13.8915L14.7264 13.1357C13.6874 12.159 12.5849 11.7762 11.4747 11.9982C9.01378 12.4784 7.43222 15.7826 7.36988 15.9248L6.14378 18.5465Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0148 3.21875C11.5326 8.25984 10.1643 8.50922 8.62102 9.89062C10.1129 9.88844 12.027 9.21359 13.5101 7.87484C15.341 6.15109 16.0312 4.33875 16.0148 3.21875Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.7182 24.9326C29.4021 25.3089 28.9417 25.4631 28.7142 25.2564C28.4757 25.0606 28.5501 24.5903 28.876 24.213C29.1932 23.8269 29.6428 23.6825 29.8801 23.8892C30.1185 24.0861 30.0442 24.5564 29.7182 24.9326Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32780_38049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSad, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sad.ff62b629.svg";
export { ForwardRef as ReactComponent };